import pic1 from './assets/img/avator/pic1.png';
import pic2 from './assets/img/avator/pic2.png';
import pic3 from './assets/img/avator/pic3.png';
import pic4 from './assets/img/avator/pic4.png';
import pic5 from './assets/img/avator/pic5.png';
import pic6 from './assets/img/avator/pic6.png';
import pic7 from './assets/img/avator/pic7.png';
import pic8 from './assets/img/avator/pic8.png';
import pic9 from './assets/img/avator/pic9.png';
import pic10 from './assets/img/avator/pic10.png';
import pic11 from './assets/img/avator/pic11.png';
import pic12 from './assets/img/avator/pic12.png';
import pic13 from './assets/img/avator/pic13.png';
import pic14 from './assets/img/avator/pic14.png';
import pic15 from './assets/img/avator/pic15.png';
import pic16 from './assets/img/avator/pic16.png';
import pic17 from './assets/img/avator/pic17.png';
import pic18 from './assets/img/avator/pic18.png';
import pic19 from './assets/img/avator/pic19.png';
import pic20 from './assets/img/avator/pic20.png';
import pic21 from './assets/img/avator/pic21.png';
import pic22 from './assets/img/avator/pic22.png';
import pic23 from './assets/img/avator/pic23.png';
import pic24 from './assets/img/avator/pic24.png';
import pic25 from './assets/img/avator/pic25.png';
import pic26 from './assets/img/avator/pic26.png';
import pic27 from './assets/img/avator/pic27.png';
import pic28 from './assets/img/avator/pic28.png';
import pic29 from './assets/img/avator/pic29.png';
import pic30 from './assets/img/avator/pic30.png';
import pic31 from './assets/img/avator/pic31.png';
import pic32 from './assets/img/avator/pic32.png';


export const menu = [
    {
        text: "2021年度風格家庭",
        to: 'Section1'
    },
    {
        text: "社群風格家庭票選",
        to: 'Section2'
    },
    {
        text: "家庭短片徵件票選",
        to: 'Section3'
    },
    {
        text: "風格單品",
        to: 'Section4'
    },
]

export const categories = [
    {
        text: '全部類別',
        id: 'all',
    }, {
        text: '療癒寶寶',
        id: 'category1',
    },
    {
        text: '美食生活',
        id: 'category2',
    },
    {
        text: '風格教養',
        id: 'category3',
    },
    {
        text: '親子穿搭',
        id: 'category4',
    },
    {
        text: '影像音樂',
        id: 'category5',
    }
]

export const handlerCategoriesMap = () => {
    const map = {};
    categories.forEach(item => {
        if (!(item.id in map)) {
            map[item.id] = item.text;
        }
    })
    return map;
};
export const posts = [
    {id: 1, picUrl: pic1, name: 'Angel安啾', categoryId: 'category4'},
    {id: 2, picUrl: pic2, name: 'Katy Ohana', categoryId: 'category1'},
    {id: 3, picUrl: pic4, name: 'Mom&Dad', categoryId: 'category5'},
    {id: 4, picUrl: pic5, name: 'Nina曹婕妤', categoryId: 'category4'},
    {id: 5, picUrl: pic6, name: 'Rice&Shine', categoryId: 'category3'},
    {id: 6, picUrl: pic3, name: 'Stay Fit with Mi-Michelle', categoryId: 'category2'},
    {id: 7, picUrl: pic7, name: 'Suki Lee', categoryId: 'category2'},
    {id: 8, picUrl: pic8, name: 'ZacZac.chiu - 飛天小柴克', categoryId: 'category1'},
    {id: 9, picUrl: pic9, name: '三胞胎-三寶飯 x 柴犬哥哥的日常', categoryId: 'category1'},
    {id: 10, picUrl: pic10, name: '小林&郭郭的小夫妻生活', categoryId: 'category2'},
    {id: 11, picUrl: pic11, name: '山姆先生這一家', categoryId: 'category5'},
    {id: 12, picUrl: pic12, name: '好圓好亮好點星', categoryId: 'category5'},
    {id: 13, picUrl: pic13, name: '朱李聯姻日常', categoryId: 'category3'},
    {id: 14, picUrl: pic14, name: '我是山東', categoryId: 'category4'},
    {id: 15, picUrl: pic15, name: '沙莫太太', categoryId: 'category3'},
    {id: 16, picUrl: pic16, name: '那對夫妻', categoryId: 'category5'},
    {id: 17, picUrl: pic17, name: '亞歷一家 family', categoryId: 'category3'},
    {id: 18, picUrl: pic18, name: '林叨囝仔 The Lins\' Kids', categoryId: 'category3'},
    {id: 19, picUrl: pic19, name: '流氓夫妻', categoryId: 'category2'},
    {id: 20, picUrl: pic20, name: '唐葳', categoryId: 'category4'},
    {id: 21, picUrl: pic21, name: '茜茜與人夫謙', categoryId: 'category5'},
    {id: 22, picUrl: pic22, name: '張宇', categoryId: 'category2'},
    {id: 23, picUrl: pic23, name: '陳艾琳', categoryId: 'category4'},
    {id: 24, picUrl: pic24, name: '陳欣欣', categoryId: 'category4'},
    {id: 25, picUrl: pic25, name: '陳彥婷 Tiffany', categoryId: 'category1'},
    {id: 26, picUrl: pic26, name: '雪拚女皇', categoryId: 'category2'},
    {id: 27, picUrl: pic27, name: '鳥先生&鳥夫人', categoryId: 'category3'},
    {id: 28, picUrl: pic28, name: '曾玄玄', categoryId: 'category4'},
    {id: 29, picUrl: pic29, name: '超感動', categoryId: 'category5'},
    {id: 30, picUrl: pic30, name: '嘎嫂二伯', categoryId: 'category3'},
    {id: 31, picUrl: pic31, name: '睿咩Rimmy', categoryId: 'category2'},
    {id: 32, picUrl: pic32, name: '蔡昕言 Ellie', categoryId: 'category4'},
];
